module.exports = __webpack_public_path__ + "media/1.a8c0d41d.mp4";